module.exports = __webpack_public_path__ + "img/python.3255f8df.svg";